function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,464.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3163 4396 c-536 -140 -929 -247 -936 -256 -8 -8 -74 -118 -147 -244 l-134 -229 -281 5 -281 6 -689 -670 c-380 -369 -691 -676 -693 -682 -1 -7 308 -314 688 -684 l691 -672 287 -2 286 -3 137 -234 c76 -130 146 -238 156 -242 82 -29 1876 -490 1882 -483 4 5 121 420 259 922 l252 913 -141 236 c-88 148 -138 242 -134 252 3 9 67 117 140 241 l135 226 -253 919 c-246 891 -254 920 -278 921 -13 1 -439 -107 -946 -240z m240 -505 c-15 -26 -199 -337 -408 -689 l-380 -641 -823 -1 -823 0 506 503 c279 276 517 508 529 515 18 12 1378 359 1414 361 9 1 4 -15 -15 -48z m650 -887 l195 -681 -196 -687 c-109 -377 -199 -686 -202 -686 -3 0 -189 309 -413 686 l-408 686 98 166 c496 839 719 1209 724 1204 4 -4 95 -314 202 -688z m-1029 -1600 c224 -377 406 -688 403 -690 -2 -3 -323 75 -713 172 l-709 177 -515 513 -515 514 821 0 820 0 408 -686z"
}));

function SvgUnityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.18 0.38 463.83 463.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityLogo);
export default __webpack_public_path__ + "static/media/unity_logo.39ce863a.svg";
export { ForwardRef as ReactComponent };